import { BaseOperationModel } from '../base-operation-model';

export class MicrosoftOfficeStopPermanentAuditResourcesModel extends BaseOperationModel {
}
